var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { FilterExpression } from "./FilterExpression.js";
import _ from "lodash";
import { FilterDisjunctionContext, FilterConjunctionContext, FilterGroupContext, FilterBinaryContext, FilterInContext, FilterBetweenContext } from "../antlr/FilterExpressionParser.js";
const expressionParser = (expression) => {
  const result = {};
  if (!expression) {
    return result;
  }
  const parseTree = FilterExpression.parse(expression);
  _.forEach(parseTree.filterExpr(), (filterExpr) => {
    const { filterKey, filterValue } = processFilterExpr(filterExpr);
    result[filterKey] = filterValue;
  });
  return result;
};
const processFilterExpr = (context) => {
  if (context instanceof FilterDisjunctionContext) {
    const { filterKey, filterValue: audienceFilter1 } = processFilterExpr(
      context.getChild(0)
    );
    const { filterKey: k, filterValue: audienceFilter2 } = processFilterExpr(
      context.getChild(2)
    );
    return {
      filterKey,
      filterValue: {
        clause: { firstOrFilter: audienceFilter1, secondOrFilter: audienceFilter2 },
        type: "OR"
      }
    };
  } else if (context instanceof FilterConjunctionContext) {
    const { filterKey, filterValue: audienceFilter1 } = processFilterExpr(
      context.getChild(0)
    );
    const { filterKey: k, filterValue: audienceFilter2 } = processFilterExpr(
      context.getChild(2)
    );
    return {
      filterKey,
      filterValue: {
        clause: { firstAndFilter: audienceFilter1, secondAndFilter: audienceFilter2 },
        type: "AND"
      }
    };
  } else if (context instanceof FilterGroupContext) {
    const { filterKey, filterValue: audienceFilter } = processFilterExpr(
      context.getChild(1)
    );
    return {
      filterKey,
      filterValue: __spreadValues({}, audienceFilter)
    };
  } else {
    return processFilterExprBase(context);
  }
};
const processFilterExprBase = (context) => {
  var _a, _b, _c, _d, _e;
  const filterConditionContext = context.getChild(0);
  if (filterConditionContext instanceof FilterBinaryContext) {
    return {
      filterKey: filterConditionContext.VARIANT().text,
      filterValue: {
        clause: {
          operator: (_a = filterConditionContext._op.text) != null ? _a : "",
          values: sanitizeText((_c = (_b = filterConditionContext.literal()) == null ? void 0 : _b.text) != null ? _c : ""),
          type: "SingleValue"
        },
        type: "Base"
      }
    };
  } else if (filterConditionContext instanceof FilterInContext) {
    return {
      filterKey: filterConditionContext.VARIANT().text,
      filterValue: {
        clause: {
          operator: (_d = filterConditionContext._op.text) != null ? _d : "",
          values: [
            ...filterConditionContext.literalList().literal().map((l) => sanitizeText(l.text))
          ],
          type: "ListOfValues"
        },
        type: "Base"
      }
    };
  } else if (filterConditionContext instanceof FilterBetweenContext) {
    return {
      filterKey: filterConditionContext.VARIANT().text,
      filterValue: {
        clause: {
          operator: (_e = filterConditionContext.BETWEEN().text) != null ? _e : "",
          values: [
            sanitizeText(filterConditionContext.literal(0).text),
            sanitizeText(filterConditionContext.literal(1).text)
          ],
          type: "ListOfValues"
        },
        type: "Base"
      }
    };
  }
  return {
    filterKey: "Unknown",
    filterValue: {
      clause: {
        operator: "Unknown",
        values: [],
        type: "ListOfValues"
      },
      type: "Base"
    }
  };
};
const sanitizeText = (text) => {
  return text == null ? void 0 : text.replace(/"/g, "");
};
export {
  expressionParser,
  processFilterExpr,
  processFilterExprBase,
  sanitizeText
};
//# sourceMappingURL=ExpressionParser.js.map
